import { PharmacyCardsList } from '@ui/checkout/pharmacy-card';
import { useStoresList } from '../../../entites/store/use-stores-list.ts';

export const AllStoresList = ({
  query,
  selectedCityId,
  isDivided,
}: {
  query?: string;
  selectedCityId?: number;
  isDivided?: boolean;
}) => {
  const { data } = useStoresList({ query, selectedCityId });

  return <PharmacyCardsList isDivided={isDivided} items={data} />;
};
